// LandlordSidebar.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../styles/Landlord/LandlordSidebar.module.css';

const LandlordSidebar = ({ activeTab }) => {
  const navigate = useNavigate();

  const handleNavigation = (tab) => {
    switch(tab) {
      case 'dashboard':
        navigate('/landlord');
        break;
      case 'properties':
        navigate('/landlord/properties');
        break;
      case 'applications':
        navigate('/landlord/applications');
        break;
      case 'settings':
        navigate('/landlord');
        break;
      default:
        navigate('/landlord');
    }
  };

  return (
    <div className={styles.sidebar}>
      <ul>
        <li className={activeTab === 'dashboard' ? styles.active : ''} onClick={() => handleNavigation('dashboard')}>
          Dashboard
        </li>
        <li className={activeTab === 'properties' ? styles.active : ''} onClick={() => handleNavigation('properties')}>
          Properties
        </li>
        <li className={activeTab === 'applications' ? styles.active : ''} onClick={() => handleNavigation('applications')}>
          Applications
        </li>
        <li className={activeTab === 'settings' ? styles.active : ''} onClick={() => handleNavigation('settings')}>
          Settings
        </li>
      </ul>
    </div>
  );
};

export default LandlordSidebar;
